import React, { memo, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Button, Modal, Spin, Progress, Row, Col } from 'antd';
import { makeSelectUser } from '@/global.selectors';
import request from '@utils/request';
import { awaitWrapper } from 'utils/helper';

class UpdateSapo extends PureComponent {
  constructor() {
    super();
    this.state = {
      showModal: false,
      isProcessing: false,
      dataList: [],
      currentProcessIndex: 0,
      resetMode: false,
    }
    this.currentProcessIndex = 0;
    this.tDoUpdate = null;
  }
  handleOpenModal = () => {
    this.setState({ showModal: true });
  }
  handleUpdate = () => {
    if (this.state.isProcessing) {
      this.setState({ isProcessing: false });
    } else {
      this.setState({ isProcessing: true });
      this.currentProcessIndex = 0;
      const dataList = this.props.list.filter(x => x.pId);
      this.setState({ dataList, currentProcessIndex: 0 }, () => this.doUpdate());
    }

  }
  doUpdate = async () => {
    if (!this.state.isProcessing || this.currentProcessIndex >= this.state.dataList.length) {
      this.setState({ isProcessing: false });
      return;
    }
    const item = this.getCurrentItem();// this.state.dataList[this.currentProcessIndex];
    const id = item.pId;
    const [err, resData] = await awaitWrapper(request.get(`v1/product-meta/sapo-product/${id}`));
    if(!err){
        const {product} = resData.data;
        const updateData = {
            id: product.id,
            variants: []
        }
        product.variants.forEach(variant => {
            const variantData = {
                id: variant.id,
                variant_prices: []
            }
            const priceList = variant.variant_prices.map(x => {
                const data = {
                    ...x
                }
                delete data.price_list;
                if(data.price_list_id === 2339974){
                    data.value = item.salePrice;
                }
                return data;
            })
            variantData.variant_prices = priceList;
            updateData.variants.push(variantData);
        })
        const [putErr, putResData] = await awaitWrapper(request.put(`v1/product-meta/sapo-product/${id}`, updateData));
        console.log(putErr, putResData);
    }
    
    clearTimeout(this.tDoUpdate);
    this.currentProcessIndex += 1;
    if (!this.props.singleMode && this.currentProcessIndex < this.state.dataList.length) {
      this.tDoUpdate = setTimeout(() => { this.doUpdate(); }, 50);
      this.setState({ currentProcessIndex: this.currentProcessIndex });
    } else {
      this.setState({
        isProcessing: false
      });
    }

    return;
  }
  getCurrentItem = () => {
    if(this.props.singleMode) return this.props.item;
    return this.state.dataList[this.state.currentProcessIndex] || {};
  }
  render() {
    if (this.props.user.role > 1) return '';
    const { showModal, isProcessing } = this.state;
    const { loading, resetMode } = this.props;
    const currentItem = this.getCurrentItem();
    const progress = isProcessing ? Math.round(((this.state.currentProcessIndex + 1) / this.state.dataList.length) * 100) : 0;
    const title = `Cập nhật giá Sapo: ${currentItem.pName || ''}`;
    return (
      <>
        {this.props.singleMode ? <Button title="Update Sapo" icon="cloud-upload" onClick={this.handleOpenModal} /> :<Button onClick={this.handleOpenModal}>Cập nhật Sapo</Button>}
        {showModal &&
          <Modal width="40%" title={title} visible onCancel={() => this.setState({ showModal: false })} footer={null}>
            <Spin spinning={loading}>
              <Row>
                <Col sm={24}>
                  <Progress percent={progress} />
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <Button disabled={this.props.loading} onClick={this.handleUpdate} type="primary">{isProcessing ? 'Stop' : 'Start'}</Button>
                </Col>
                <Col sm={12}>
                  <Button onClick={this.handleUpdate} type="primary">{isProcessing ? 'Stop' : 'Start'}</Button>
                </Col>
              </Row>
              {isProcessing && <Row>
                <Col sm={12}>Updating: {currentItem.pName}</Col>
              </Row>}
            </Spin>
          </Modal>}
      </>
    );
  }
}

UpdateSapo.propTypes = {
  list: PropTypes.array,
  loading: PropTypes.bool,
  singleMode: PropTypes.bool,
  item: PropTypes.object,
};

UpdateSapo.defaultProps = {
  list: [],
  loading: false,
  singleMode: false,
  item: {},
};

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});

const mapDispatchToProps = dispatch => ({
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(UpdateSapo);
